import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight,faCheck  } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
export default function WhyChooseSection() {
    const cards = [
  {
    title: "Rent",
    points: [
      "2000+ Verified Flats & Houses",
      "No Brokerage or Middlemen",
      "Ready-to-Move Properties",
      "Flexible Deposit Options",
      "Available Across Bangalore"
    ],
    link: "/properties",
    button: "View Rentals",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 16L6.66667 13.3333M6.66667 13.3333L16 4L25.3333 13.3333M6.66667 13.3333V26.6667C6.66667 27.4026 7.26411 28 8 28H12M25.3333 13.3333L28 16M25.3333 13.3333V26.6667C25.3333 27.4026 24.7359 28 24 28H20M12 28C12.7359 28 13.3333 27.4026 13.3333 26.6667V21.3333C13.3333 20.5974 13.9308 20 14.6667 20H17.3333C18.0692 20 18.6667 20.5974 18.6667 21.3333V26.6667C18.6667 27.4026 19.2641 28 20 28M12 28H20" stroke="#FF3155" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

    )
  },
  {
    title: "Buy",
    points: [
      "Transparent Fixed Pricing",
      "No Brokerage or Hidden Charges",
      "Pay Fees Only on Deal Completion",
      "Access to Premium Properties",
      "Exclusive Property Listings"
    ],
    link: "/buy/list",
    button: "Find Properties to Buy",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.3333 28V6.66667C25.3333 5.19489 24.1384 4 22.6667 4H9.33333C7.86156 4 6.66667 5.19489 6.66667 6.66667V28M25.3333 28H28M25.3333 28H18.6667M6.66667 28H4M6.66667 28H13.3333M12 9.33333H13.3333M12 14.6667H13.3333M18.6667 9.33333H20M18.6667 14.6667H20M13.3333 28V21.3333C13.3333 20.5974 13.9308 20 14.6667 20H17.3333C18.0692 20 18.6667 20.5974 18.6667 21.3333V28M13.3333 28H18.6667" stroke="#FF3155" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
  },
  {
    title: "Sell",
    points: [
      "Free Property Marketing",
      "Pay Fee Only After Successful Sale",
      "No Middlemen Involved",
      "Competitive Market Valuation",
      "Exclusive Listing Support"
    ],
    link: "/sell",
    button: "List Your Property",
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 18.6667V22.6667M21.3333 18.6667V22.6667M4 28H28M4 13.3333H28M4 9.33333L16 4L28 9.33333" stroke="#FF3155" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.667 18V22.6667" stroke="#FF3155" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.33301 13.3333V27.9999H26.6663V13.3333H5.33301ZM5.33301 13.3333V13.5" stroke="#FF3155" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
  }
];
  return (
    <section className="why-choose-us ">
  <div className="container">
    <div className='row'>
        <div className='col-md-12'>
            <div class="section-heading align-items-start"><h2>One Platform for <span class="pink-text"> Buying, Selling and Renting?</span></h2></div>
        </div>
    </div>

    <div className="row g-4">
    {cards.map((card, index) => (
    <div className="col-lg-4 col-md-6" key={index}>
      <div className="why-card">

        <div className="why-card-header d-flex align-items-center">
          <div className="why-icon">
            {card.icon}
          </div>
          <h4>{card.title}</h4>
        </div>

        <ul className="why-list">
          {card.points.map((point, i) => (
            <li key={i}>
                 <FontAwesomeIcon icon={faCheck} className="why-check-icon me-2" />{point}</li>
          ))}
        </ul>

        <Link to={card.link}>
          <span className="why-btn">
            {card.button}
            <FontAwesomeIcon icon={faArrowRight} className="ms-2" />
          </span>
        </Link>

      </div>
    </div>
  ))}

    

    </div>
  </div>
</section>
  )
}
